/**
 * State filtering for the survey responses list. The list is sorted newest-first across all states
 * (completed / in-progress / abandoned); these helpers let the viewer narrow to one state and show
 * counts on the filter pills. A row with no `state` is a legacy completed response.
 */

export type StateFilter = 'all' | 'completed' | 'in_progress' | 'abandoned';

export const STATE_FILTERS: { key: StateFilter; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'completed', label: 'Completed' },
  { key: 'in_progress', label: 'In progress' },
  { key: 'abandoned', label: 'Abandoned' },
];

interface HasState {
  state?: string;
}

const isCompleted = (r: HasState): boolean => !r.state || r.state === 'completed';

export function countResponsesByState<T extends HasState>(rows: T[]): Record<StateFilter, number> {
  return {
    all: rows.length,
    completed: rows.filter(isCompleted).length,
    in_progress: rows.filter((r) => r.state === 'in_progress').length,
    abandoned: rows.filter((r) => r.state === 'abandoned').length,
  };
}

export function filterResponsesByState<T extends HasState>(rows: T[], filter: StateFilter): T[] {
  if (filter === 'all') return rows;
  if (filter === 'completed') return rows.filter(isCompleted);
  return rows.filter((r) => r.state === filter);
}
